import incentiveByItem from '@/api/promotion/incentive-by-item'

import { baseState, baseMutations } from '@/store/mixins'
import { split } from 'lodash'

export const state = {
  ...baseState,
  formViewDatas: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_VIEW_MODELS(state, { data, index }) {
    if (!index) {
      state.formViewDatas = data;
    } else {
      split(index, ",").forEach(el => {
        state.formViewDatas[el] = data[el];
      });
    }
  },
}

export const actions = {
  store(context, data) {
    return incentiveByItem.store(data)
  },
  update(context, { id, data }) {
    return incentiveByItem.update(id, data)
  },
  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await incentiveByItem.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },
  async getFormViewModel(context, { params, index }) {
    let response = await incentiveByItem.formViewModel({ params: params });
    context.commit("SET_VIEW_MODELS", {
      data: response.data,
      index: index
    });
    return Promise.resolve(response);
  }
}